export default __webpack_public_path__ + "static/media/waiting.43d48d65.svg";